import React from 'react';

function Page4SubPageB2() {
    return <h1>Following</h1>;
}

export default Page4SubPageB2;